import { FC } from 'react';

import ErrorView from 'components/ErrorView';
import { useNewInsuranceCoverage } from 'features/Insurance/hooks/useNewInsuranceCoverage';

import PageWrapper from '../../../components/PageWrapper';
import CompleteGuaranteesList from '../../../components/PageWrapper/components/CompleteGuaranteesList';
import offers from '../../../offers';
import * as routes from '../../../routes';
import { AssuredBy, isSelectedProviderPlanId } from '../../../types';
import cover from '../assets/cover.png';
import locales from './locales';
import { prices } from './types';

const OFFER_NAME = 'Transport Delay';
const PAGE_NAME = `Insurance${OFFER_NAME.replaceAll(' ', '')}OfferDetails Viewed`;

const TransportDelay: FC = () => {
  const { coverage, planId, routeState } = useNewInsuranceCoverage();

  if (!isSelectedProviderPlanId(planId)) {
    return <ErrorView />;
  }

  const { isCovered, isCoveredFromPlan } = coverage.transportDelay;

  const guarantees = {
    ...locales.content,
    include: {
      ...locales.content.include,
      items: locales.content.include.items.map((text, index) =>
        index === 0
          ? (locales.formatString(text, prices[planId]) as string)
          : text,
      ),
    },
  };

  return (
    <PageWrapper
      assuredBy={AssuredBy.MutuaideAssistance}
      backButtonLink={routes.coverage}
      coverImage={cover}
      from={routeState.from}
      intercomMessage={locales.claimButton.intercomMessage}
      isCovered={isCovered}
      isCoveredFromPlan={isCoveredFromPlan}
      offer={offers.transportDelay}
      offerName={OFFER_NAME}
      pageName={PAGE_NAME}
      similarOffers={[offers.rentalVehicle, offers.healthCostsAbroad]}
    >
      <CompleteGuaranteesList guarantees={guarantees} />
    </PageWrapper>
  );
};

export default TransportDelay;
